(function() {
	'use strict';
	angular.module('app.core')
		.directive('datepickerPopup', datepickerPopup);
	
	datepickerPopup.$inject = [];
	function datepickerPopup() {
		 return {
	        restrict: 'EAC',
	        require: 'ngModel',
	        link: function(scope, element, attr, controller) {
		      //remove the default formatter from the input directive to prevent conflict
		      controller.$formatters.shift();
	        }
	    };
	}
})();